<template>
    <div class="full-width q-py-xs">
        <q-card class="full-width full-height no-shadow border-grey">
            <q-form @submit="submit">
                <q-card-section>
                    <div class="row justify-between">
                        <!-- Fields column (breaks down to 2 columns on medium devices, single column on small devices) -->
                        <div class="col-9">
                            <div class="row">
                                <div class="col-12">
                                    <banner
                                        class="q-mb-md"
                                        :is-visible="!end && inlineEditMode"
                                        type="info"
                                        :message="$t(editPhaseInfoMessage)"
                                    />
                                </div>
                                <!-- First column of fields -->
                                <div class="col-xs-12 col-md-6 full-height">
                                    <q-chip
                                        v-if="!inlineEditMode"
                                        :color="
                                            ASSET_STATUS_TO_STYLE[phase][
                                                'color'
                                            ]
                                        "
                                        :label="
                                            $t(
                                                ASSET_STATUS_TO_STYLE[phase][
                                                    'label'
                                                ]
                                            )
                                        "
                                        class="q-mx-none q-mb-sm text-uppercase"
                                        text-color="white"
                                        style="font-weight: 500"
                                        square
                                    >
                                    </q-chip>
                                    <div
                                        v-else
                                        class="col-xs-12 col-md-6 full-height q-mr-sm"
                                    >
                                        <q-select
                                            v-model="form.status"
                                            :label="$t('Status')"
                                            :options="statusOptions"
                                            class="q-mb-md full-width"
                                            outlined
                                            lazy-rules
                                            :disable="true"
                                            color="accent"
                                        >
                                            <!-- Option style -->
                                            <template v-slot:option="scope">
                                                <q-item
                                                    v-bind="scope.itemProps"
                                                    v-on="scope.itemEvents"
                                                >
                                                    <q-item-section class="row">
                                                        <div>
                                                            <q-icon
                                                                :color="
                                                                    ASSET_STATUS_TO_STYLE[
                                                                        scope
                                                                            .opt
                                                                            .value
                                                                    ]['color']
                                                                "
                                                                name="fas fa-circle"
                                                                class="q-mr-sm"
                                                            ></q-icon>
                                                            {{
                                                                $t(
                                                                    scope.opt
                                                                        .label
                                                                )
                                                            }}
                                                        </div>
                                                    </q-item-section>
                                                </q-item>
                                            </template>
                                            <!-- Selected item style -->
                                            <template v-slot:selected>
                                                <q-icon
                                                    :color="
                                                        form.status['color']
                                                    "
                                                    style="margin-bottom: 2px"
                                                    name="fas fa-circle"
                                                ></q-icon>
                                                <div style="margin-left: 5px">
                                                    {{
                                                        $t(form.status['label'])
                                                    }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <!-- Date range field -->
                                    <div v-if="!inlineEditMode" class="row">
                                        <q-icon
                                            name="far fa-calendar-alt"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                            :style="
                                                $q.screen.lt.sm
                                                    ? 'margin-top:6px;'
                                                    : ''
                                            "
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Date range') }}
                                            </q-tooltip>
                                        </q-icon>
                                        <div
                                            v-if="end === null"
                                            class="q-ml-xs"
                                        >
                                            <span
                                                :class="
                                                    $q.screen.lt.sm
                                                        ? 'span-display-block'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    formatDate(
                                                        start,
                                                        userLocale
                                                    )
                                                }}</span
                                            >
                                            <span
                                                :class="
                                                    $q.screen.lt.sm
                                                        ? 'span-display-block'
                                                        : ''
                                                "
                                            >
                                                {{ ` (${$t('Ongoing')})` }}
                                            </span>
                                        </div>
                                        <div
                                            v-else
                                            class="q-ml-xs"
                                            style="margin-top: 2px"
                                        >
                                            <span
                                                :class="
                                                    $q.screen.lt.sm
                                                        ? 'span-display-block'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    formatDate(
                                                        start,
                                                        userLocale
                                                    )
                                                }}
                                            </span>
                                            <span
                                                :class="
                                                    $q.screen.lt.sm
                                                        ? 'span-display-none'
                                                        : ''
                                                "
                                            >
                                                -
                                            </span>
                                            <span
                                                :class="
                                                    $q.screen.lt.sm
                                                        ? 'span-display-block'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    formatDate(end, userLocale)
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                    <div
                                        v-else
                                        class="col-xs-12 col-md-6 full-height q-mr-sm"
                                        :class="
                                            $q.screen.lt.sm
                                                ? 'span-display-block'
                                                : ''
                                        "
                                    >
                                        <date-time-picker
                                            v-model="form.start"
                                            :label="$t('Start')"
                                            :disable="true"
                                        ></date-time-picker>
                                        <date-time-picker
                                            v-model="form.end"
                                            :label="$t('End')"
                                            :disable="true"
                                            :style="
                                                $q.screen.lt.md
                                                    ? 'margin-top: 16px;'
                                                    : 'margin-top: -4px;'
                                            "
                                        ></date-time-picker>
                                        <div
                                            class="col-xs-12 col-md-6 full-height"
                                            :class="
                                                $q.screen.lt.md ? 'q-pt-md' : ''
                                            "
                                        >
                                            <q-select
                                                v-if="proximityReading !== null"
                                                v-model="form.proximityReading"
                                                :options="
                                                    proximitySensorOptions
                                                "
                                                :label="$t('Product on line?')"
                                                class="full-width"
                                                outlined
                                                emit-value
                                                map-options
                                                color="accent"
                                            >
                                                <!-- Option style -->
                                                <template v-slot:option="scope">
                                                    <q-item
                                                        v-bind="scope.itemProps"
                                                        v-on="
                                                            scope.itemEvents ||
                                                            {}
                                                        "
                                                    >
                                                        <q-item-section
                                                            class="row"
                                                        >
                                                            <div>
                                                                {{
                                                                    $t(
                                                                        scope
                                                                            .opt
                                                                            .label
                                                                    )
                                                                }}
                                                            </div>
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                                <!-- Selected item style -->
                                                <template v-slot:selected>
                                                    <div
                                                        style="margin-left: 5px"
                                                    >
                                                        {{
                                                            getProximityLabel(
                                                                form.proximityReading
                                                            )
                                                        }}
                                                    </div>
                                                </template>
                                            </q-select>
                                        </div>
                                    </div>
                                    <!-- Duration field (Total production)-->
                                    <div class="q-mt-xs" v-if="!inlineEditMode">
                                        <q-icon
                                            name="far fa-ban"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('No Product Duration') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ productDuration }}
                                    </div>
                                    <!-- Duration field (OEE) -->
                                    <div v-if="!inlineEditMode" class="q-mt-xs">
                                        <q-icon
                                            name="far fa-stopwatch"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Phase Duration') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ phaseDuration + ` (${$t('OEE')})` }}
                                    </div>
                                    <!-- Proximity Sensor Reading field (OEE) -->
                                    <div
                                        v-if="
                                            !inlineEditMode &&
                                            proximityReading !== null
                                        "
                                        class="q-mt-xs"
                                    >
                                        <q-icon
                                            :name="
                                                proximityReading
                                                    ? 'far fa-sensor-on'
                                                    : 'far fa-sensor'
                                            "
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Product on line?') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{
                                            getProximityLabel(proximityReading)
                                        }}
                                    </div>
                                </div>

                                <!-- Second column of fields -->
                                <div
                                    v-if="!inlineEditMode"
                                    class="col-xs-12 col-md-6 full-height"
                                >
                                    <div class="q-my-xs">
                                        <q-icon
                                            name="far fa-conveyor-belt"
                                            class="q-mr-xs"
                                            color="grey"
                                            size="sm"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Asset') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ assetName }}
                                    </div>
                                    <div v-if="product" class="q-mt-xs">
                                        <q-icon
                                            name="far fa-box"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Product') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ productName }}
                                    </div>
                                    <div v-if="cause" class="q-mt-xs">
                                        <q-icon
                                            name="far fa-exclamation-circle"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Cause') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ causeName }}
                                    </div>
                                    <div v-else class="q-mt-xs">
                                        <div
                                            v-if="isMajor"
                                            class="missing-cause"
                                        >
                                            <!-- Show list of causes -->
                                            <missing-cause-label
                                                v-model="
                                                    causeSelectProps.selection
                                                "
                                                :phaseId="eventId"
                                                :phaseEnd="end"
                                                :phaseUUID="eventUUID"
                                                @refreshList="refreshList"
                                                @clearSelection="
                                                    causeSelectProps.selection =
                                                        null
                                                "
                                                :baseURL="causeSelectProps.url"
                                                :queryParams="
                                                    causeSelectProps.queryParams
                                                "
                                                :label="causeSelectProps.label"
                                                :dialogTitle="
                                                    causeSelectProps.dialogTitle
                                                "
                                                :searchLabel="
                                                    causeSelectProps.searchLabel
                                                "
                                                row-key="id"
                                                :isFlat="true"
                                            >
                                                <template v-slot:item="data">
                                                    <cause-card
                                                        @select="
                                                            select(
                                                                data.props.row
                                                                    .id,
                                                                data.props.row
                                                                    .name,
                                                                causeSelectProps
                                                            )
                                                        "
                                                        :name="
                                                            data.props.row.name
                                                        "
                                                        :lossType="
                                                            data.props.row
                                                                .type_of_loss
                                                        "
                                                        :categoryName="
                                                            data.props.row
                                                                .category_name
                                                        "
                                                        :planned="
                                                            data.props.row
                                                                .planned
                                                        "
                                                        :description="
                                                            data.props.row
                                                                .description
                                                        "
                                                        :targetDowntime="
                                                            data.props.row
                                                                .target_down_time
                                                        "
                                                        :isSelected="
                                                            causeSelectProps.selection &&
                                                            causeSelectProps
                                                                .selection
                                                                .value ===
                                                                data.props.row
                                                                    .id
                                                        "
                                                        :isSelectable="true"
                                                        :equipmentFailure="
                                                            data.props.row
                                                                .equipment_failure
                                                        "
                                                    ></cause-card>
                                                </template>
                                            </missing-cause-label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Second column of fields Edit Mode -->
                                <div
                                    v-else
                                    class="col-xs-12 col-md-6 full-height"
                                >
                                    <div class="q-mr-sm">
                                        <!-- asset dropdown -->
                                        <q-select
                                            v-model="form.asset"
                                            :options="assetOptions"
                                            :label="$t('Asset')"
                                            :rules="[
                                                val =>
                                                    (val !== '' &&
                                                        val !== null) ||
                                                    $t('Select an asset')
                                            ]"
                                            :class="
                                                $q.screen.lt.md
                                                    ? 'q-my-md full-width'
                                                    : ''
                                            "
                                            behavior="dialog"
                                            disable
                                            clearable
                                            outlined
                                            emit-value
                                            map-options
                                            color="accent"
                                        />
                                    </div>
                                    <div
                                        :class="
                                            $q.screen.lt.md
                                                ? 'q-my-md'
                                                : 'q-my-md q-mb-md'
                                        "
                                        class="q-mr-sm"
                                    >
                                        <table-select
                                            v-model="form.product"
                                            @confirmSelection="
                                                form.product =
                                                    productSelectProps.selection
                                            "
                                            :baseURL="productSelectProps.url"
                                            :queryParams="
                                                productSelectProps.queryParams
                                            "
                                            :label="productSelectProps.label"
                                            :dialogTitle="
                                                productSelectProps.dialogTitle
                                            "
                                            :searchLabel="
                                                productSelectProps.searchLabel
                                            "
                                            row-key="id"
                                            class="q-mb-sm"
                                            :disable="
                                                !isPhaseEditable(end) ||
                                                isPhaseInProgress(end)
                                            "
                                        >
                                            <template v-slot:item="data">
                                                <product-card
                                                    @select="
                                                        select(
                                                            data.props.row
                                                                .product,
                                                            data.props.row.name,
                                                            productSelectProps
                                                        )
                                                    "
                                                    :name="data.props.row.name"
                                                    :code="data.props.row.code"
                                                    :description="
                                                        data.props.row
                                                            .description
                                                    "
                                                    :unit-measure="
                                                        data.props.row
                                                            .unit_measure
                                                    "
                                                    :unit-packing="
                                                        data.props.row
                                                            .unit_packing
                                                    "
                                                    :isSelected="
                                                        productSelectProps.selection &&
                                                        productSelectProps
                                                            .selection.value ===
                                                            data.props.row
                                                                .product
                                                    "
                                                    :isSelectable="true"
                                                ></product-card>
                                            </template>
                                        </table-select>
                                    </div>
                                    <div class="q-mr-sm q-mb-md">
                                        <cause-table-select
                                            v-model="form.cause"
                                            @confirmSelection="
                                                form.cause =
                                                    causeSelectProps.selection
                                            "
                                            :baseURL="causeSelectProps.url"
                                            :queryParams="
                                                causeSelectProps.queryParams
                                            "
                                            :label="causeSelectProps.label"
                                            :dialogTitle="
                                                causeSelectProps.dialogTitle
                                            "
                                            :searchLabel="
                                                causeSelectProps.searchLabel
                                            "
                                            :facilityId="
                                                causeSelectProps.facilityId
                                            "
                                            row-key="id"
                                            class="q-mb-sm"
                                            :disable="!isPhaseEditable(end)"
                                        >
                                            <template v-slot:item="data">
                                                <cause-card
                                                    @select="
                                                        select(
                                                            data.props.row.id,
                                                            data.props.row.name,
                                                            causeSelectProps
                                                        )
                                                    "
                                                    :name="data.props.row.name"
                                                    :lossType="
                                                        data.props.row
                                                            .type_of_loss
                                                    "
                                                    :categoryName="
                                                        data.props.row
                                                            .category_name
                                                    "
                                                    :planned="
                                                        data.props.row.planned
                                                    "
                                                    :description="
                                                        data.props.row
                                                            .description
                                                    "
                                                    :targetDowntime="
                                                        data.props.row
                                                            .target_down_time
                                                    "
                                                    :isSelected="
                                                        causeSelectProps.selection &&
                                                        causeSelectProps
                                                            .selection.value ===
                                                            data.props.row.id
                                                    "
                                                    :isSelectable="true"
                                                    :equipmentFailure="
                                                        data.props.row
                                                            .equipment_failure
                                                    "
                                                ></cause-card>
                                            </template>
                                        </cause-table-select>
                                    </div>
                                    <q-input
                                        v-model="form.description"
                                        :label="$t('Description')"
                                        :input-style="'min-height: 45px; max-height: 90px;'"
                                        color="accent"
                                        type="textarea"
                                        class="q-mb-sm q-mr-sm"
                                        outlined
                                        :disable="!isPhaseEditable(end)"
                                    ></q-input>
                                </div>

                                <div
                                    v-if="
                                        !inlineEditMode &&
                                        description.length > 0
                                    "
                                    class="q-mt-xs"
                                >
                                    <div>
                                        <q-icon
                                            name="far fa-file-alt"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Description') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ description }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Action column -->
                        <div
                            v-if="!inlineEditMode"
                            class="col-2 col-sm-3"
                            align="right"
                        >
                            <!-- Edit Button -->
                            <q-btn
                                @click="
                                    () => {
                                        inlineEditMode = true;
                                    }
                                "
                                :disable="
                                    !isPhaseEditable(end) ||
                                    $userCannot('edit', 'phases')
                                "
                                :size="gridButtonSize"
                                class="q-mr-sm q-my-sm bg-white"
                                color="accent"
                                icon="fas fa-edit"
                                outline
                            >
                                <q-tooltip
                                    v-if="getUneditableErrorMessage(end)"
                                >
                                    {{ getUneditableErrorMessage(end) }}
                                </q-tooltip>
                            </q-btn>
                            <!-- "Split event" button -->
                            <q-btn
                                @click="$emit('split')"
                                :disable="$userCannot('split', 'phases')"
                                :size="gridButtonSize"
                                :color="
                                    $userCan('split', 'phases')
                                        ? 'warning'
                                        : 'grey'
                                "
                                class="q-mr-sm q-my-sm bg-white"
                                outline
                            >
                                <q-icon
                                    style="text-align: center; font-weight: 900"
                                    name="call_split"
                                ></q-icon>
                                <q-tooltip>{{
                                    $t('Split the event')
                                }}</q-tooltip>
                            </q-btn>
                            <q-btn
                                @click="
                                    $router.push({
                                        name: 'asset_timeline',
                                        params: {
                                            assetId: assetId
                                        },
                                        query: {
                                            datetime: start
                                        }
                                    })
                                "
                                class="q-mr-sm q-my-sm bg-white"
                                :size="gridButtonSize"
                                icon="fas fa-history"
                                color="accent"
                                no-caps
                                outline
                            >
                                <q-tooltip>{{
                                    $t('Go to the phase timeline of this asset')
                                }}</q-tooltip>
                            </q-btn>
                        </div>
                        <q-card-actions
                            v-else
                            class="col-3"
                            align="right"
                            vertical
                        >
                            <q-btn
                                type="submit"
                                class="q-pa-sm q-mb-sm"
                                :loading="loading"
                                :disable="!formHasChanged"
                                icon="fas fa-check"
                                color="positive"
                                text-color="white"
                                :size="gridButtonSize"
                            >
                                <q-tooltip>
                                    {{ $t('Save') }}
                                </q-tooltip>
                            </q-btn>
                            <q-btn
                                @click="cancelEditing"
                                class="q-pa-sm"
                                icon="fas fa-times"
                                color="negative"
                                :size="gridButtonSize"
                                outline
                            >
                                <q-tooltip>
                                    {{ $t('Cancel') }}
                                </q-tooltip>
                            </q-btn>
                        </q-card-actions>
                    </div>
                </q-card-section>
            </q-form>
        </q-card>
    </div>
</template>
<script>
import { ASSET_STATUS_TO_STYLE, STATUS_OPTIONS } from '@models/assets.js';
import {
    PROXIMITY_SENSOR_OPTIONS,
    PROXIMITY_SENSOR_LABELS
} from '@models/devices.js';
import DateTimePicker from '@components/DateTimePicker.vue';
import CauseCard from '@components/CauseCard.vue';
import ProductCard from '@components/ProductCard.vue';
import TableSelect from '@components/TableSelect.vue';
import CauseTableSelect from '@components/CauseTableSelect.vue';

import {
    LOCALE_DATETIME_FORMAT,
    getLocaleFormat
} from '@models/timeformats.js';
import MissingCauseLabel from '@components/MissingCauseLabel.vue';
import {
    isPhaseEditable,
    isPhaseInProgress,
    getUneditableErrorMessage
} from '@utils/phaseChecker.js';
import Banner from '@components/Banner.vue';
import { editPhaseInfoMessage } from '@utils/getMessages.js';
import { useSharedStore } from '@stores/shared.js';
import { mapActions, mapState } from 'pinia';
import { useAuthStore } from '@stores/auth';
import { useNotificationsStore } from '@stores/notifications.ts';

export default {
    name: 'EventCard',
    components: {
        Banner,
        CauseCard,
        CauseTableSelect,
        DateTimePicker,
        MissingCauseLabel,
        ProductCard,
        TableSelect
    },
    emits: ['split', 'save', 'refreshList'],
    props: {
        /**
         * General Object fields
         */
        facilityId: {
            type: [Number, String],
            required: false
        },
        assetId: {
            type: [Number, String],
            required: false
        },
        assetName: {
            type: String,
            required: false
        },
        /**
         * Event fields
         */
        start: {
            type: String,
            required: false
        },
        end: {
            type: String,
            required: false
        },
        eventId: {
            type: [Number, String],
            required: true
        },
        eventUUID: {
            type: String,
            required: true
        },
        phase: {
            type: String,
            required: false
        },
        status: {
            type: String,
            required: false
        },
        cause: {
            type: [Number, String],
            required: false
        },
        causeName: {
            type: String,
            required: false
        },
        product: {
            type: [Number, String],
            required: false
        },
        productName: {
            type: String,
            required: false
        },
        description: {
            type: String,
            required: false
        },
        proximityReading: {
            type: [Number, String],
            required: false,
            default: null
        },
        productDuration: {
            type: String,
            required: false
        },
        phaseDuration: {
            type: String,
            required: false
        },
        isMajor: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            // models
            ASSET_STATUS_TO_STYLE,
            LOCALE_DATETIME_FORMAT,
            PROXIMITY_SENSOR_LABELS,

            // time formats
            loading: false,
            timezone: 'local',
            inlineEditMode: false,
            statusOptions: STATUS_OPTIONS,
            assetOptions: [],
            form: {
                asset: '',
                start: null,
                end: null,
                status: null,
                cause: null,
                product: null,
                description: '',
                proximityReading: null
            },
            // selectors
            causeSelectProps: {
                url: `/assets/${this.assetId}/causes/`,
                queryParams: { ordering: 'name' },
                label: this.$t('Cause'),
                dialogTitle: this.$t('Select a cause'),
                searchLabel: this.$t('Search cause'),
                selection: null,
                facilityId: this.facilityId
            },
            productSelectProps: {
                url: `/assets/${this.assetId}/products/`,
                queryParams: { ordering: 'name' },
                label: this.$t('Product'),
                dialogTitle: this.$t('Select a product'),
                searchLabel: this.$t('Search product'),
                selection: null
            },
            proximitySensorOptions: PROXIMITY_SENSOR_OPTIONS,
            editPhaseInfoMessage
        };
    },
    watch: {
        'form.asset': {
            immediate: true,
            handler(currId, prevId) {
                // clear the dropdown if the user selects a different asset
                if (prevId && currId !== prevId) {
                    this.form.product = null;
                    this.form.cause = null;
                    // remount remote selectors
                    this.remoteSelectKey++;
                }

                // corner case: the asset id is null or empty
                if (!currId) {
                    // disable the product and cause dropdowns
                    this.disableProduct = true;
                    this.disableCause = true;
                } else {
                    // when the asset id exists enable the dropdowns
                    this.disableProduct = false;
                    this.disableCause = false;
                }
            }
        },
        eventId: {
            handler() {
                this.initForm();
            }
        },
        description: {
            handler() {
                this.initForm();
            }
        },
        end: {
            handler() {
                this.initForm();
            }
        },
        start: {
            handler() {
                this.initForm();
            }
        },
        proximityReading: {
            handler() {
                this.initForm();
            }
        }
    },
    computed: {
        ...mapState(useAuthStore, {
            userLocale: 'getUserLocale'
        }),
        /*
         * Get Grid Button Size depending on the the screen size
         * @return {String} button size
         */
        gridButtonSize() {
            return this.$q.screen.lt.xs
                ? 'sm'
                : this.$q.screen.lt.md
                  ? 'md'
                  : 'lg';
        },
        /**
         * Payload to send server to update event.
         * @return {Object}
         */
        payload() {
            const payload = {
                start: this.form.start,
                end:
                    this.form['end'] === '' || this.form['end'] === null
                        ? null
                        : this.form['end'],
                description: this.form.description,
                proximity_reading: this.form.proximityReading || null,
                cause: null,
                product: null,
                asset: parseInt(this.assetId)
            };

            if (this.form.cause) {
                payload['cause'] = parseInt(this.form.cause.value);
            }

            if (this.form.product) {
                payload['product'] = parseInt(this.form.product.value);
            }

            return payload;
        },
        /**
         * Enable the submit button when the user updates the form.
         * @return {Boolean}
         */
        formHasChanged() {
            return (
                this.dateToIsoString(this.start) !=
                    this.dateToIsoString(this.form.start) ||
                this.dateToIsoString(this.end) !=
                    this.dateToIsoString(this.form?.end) ||
                this.assetId != this.form.asset ||
                this.status != this.form.status.value ||
                this.cause != this.form.cause?.value ||
                this.product != this.form.product?.value ||
                this.description != this.form.description
            );
        }
    },
    async created() {
        // begin loading
        this.beginLoading(`${this.$t('Loading event')}...`);
        this.initForm();
        // init the options for asset dropdown
        this.initAssetOptions();

        // stop loading
        this.stopLoading();
    },
    methods: {
        ...mapActions(useSharedStore, ['beginLoading', 'stopLoading']),
        ...mapActions(useNotificationsStore, ['resolveNotificationAction']),
        isPhaseEditable,
        isPhaseInProgress,
        getUneditableErrorMessage,
        /**
         * Format a date to local date format
         * @param {String} datetime
         * @param {String} locale
         * @return {String} datetime in given locale.
         */
        formatDate(datetime, locale) {
            return getLocaleFormat(datetime, locale);
        },
        /**
         * Initialize form.
         */
        initForm() {
            this.form.asset = this.assetId;
            this.form.start = this.start;
            this.form.end = this.end;
            this.form.description = this.description;
            this.form.proximityReading = this.proximityReading || null;
            // set status option
            this.form.status = this.statusOptions.filter(
                option => option.value === this.status
            )[0];
            if (this.cause) {
                this.form.cause = {
                    label: this.causeName,
                    value: this.cause
                };
            }
            if (this.product) {
                this.form.product = {
                    label: this.productName,
                    value: this.product
                };
            }
        },
        /**
         * Save Event.
         */
        async submit() {
            if (!this.validateProduct(this.form.product?.value)) {
                this.$notifyError(
                    this.$t('Please select a product to update this event.')
                );
                return;
            }

            this.loading = true;
            const errorMessage = this.$t(
                'Failed to update event. Please try again later.'
            );
            await this.$axios
                .put(`events/${this.eventId}/`, this.payload)
                .then(response => {
                    this.$notifySuccess(this.$t('Event updated'));
                    this.$emit('save');
                })
                .catch(error => {
                    this.$notifyError(errorMessage, error);
                })
                .finally(() => {
                    this.loading = false;
                    this.inlineEditMode = false;
                });

            // If cause is part of payload, resolve the downtime in the store to
            // remove notification from notifications list
            if (this.payload.cause) {
                this.resolveNotificationAction(this.eventUUID);
            }
        },

        /**
         * Init the options of the asset dropdown
         */
        initAssetOptions() {
            // get the assets from store
            const assets = this.$store.getters['facilities/getAssets'](
                this.facilityId
            );
            // init the asset options
            assets.forEach(asset => {
                this.assetOptions.push({
                    label: asset['name'],
                    value: asset['id']
                });
            });
        },
        /**
         * Retrieve proximity sensor label from proximity reading.
         * @param {int} reading - Proximity reading
         * @return {String} - Proximity sensor label.
         */
        getProximityLabel(reading) {
            if (reading === null || reading === undefined) {
                return null;
            }
            // If the reading can not be mapped to a label, return null
            const label = PROXIMITY_SENSOR_LABELS[reading]?.label;
            return !label ? null : this.$t(label);
        },
        /**
         * Select/ deselect cause and products in table-select component
         * @param {int} rowId - ID of the cause/product
         * @param {string} rowName - Name of the cause/product
         * @param {Object} props - Table selection props (causeTableSelect, productTableSelect, MissingCauseLabel)
         * @param {Object} props.selection - currently selected cause/product
         */
        select(rowId, rowName, props) {
            if (props.selection && props.selection.value === rowId) {
                props.selection = null;
            } else {
                props.selection = {
                    label: rowName,
                    value: rowId
                };
            }
        },
        /**
         * Triggers the refresh list method from the parent component after adding a cause
         */
        refreshList() {
            this.$emit('refreshList');
        },
        /**
         * Convert a given date to ISO String and reset the milliseconds
         * @return {Date}
         */
        dateToIsoString(date) {
            const newDate = new Date(date);
            newDate.setMilliseconds(0);
            return newDate.toISOString();
        },
        /**
         * Validate product field.
         * @param {String} product
         * @return {Boolean} - Whether the field value is valid or not.
         */
        validateProduct(product) {
            // check whether product field needs to be validated
            if (this.form.status.value !== 'stopped') {
                return Boolean(product);
            } else {
                return true;
            }
        },
        /**
         * Cancel editing and reset the state of product, cause and description fields.
         */
        cancelEditing() {
            if (this.cause) {
                this.form.cause = {
                    label: this.causeName,
                    value: this.cause
                };
            } else {
                this.form.cause = null;
            }

            if (this.product) {
                this.form.product = {
                    label: this.productName,
                    value: this.product
                };
            } else {
                this.form.product = null;
            }

            if (this.description) {
                this.form.description = this.description;
            } else {
                this.form.description = null;
            }

            this.causeSelectProps.selection = null;
            this.productSelectProps.selection = null;
            this.inlineEditMode = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.missing-cause {
    color: $negative;
    font-weight: 500;
}

.span-display-block {
    display: block;
}
.span-display-none {
    display: none;
}
</style>
